import React, { type ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface Props {
  href: string;
  children: ReactNode;
  className?: string;
  title?: string;
}

/**
 * View component for links that knows which URLs can be routed client-side.
 */
export default function Link({
  href,
  children,
  className,
  title,
}: Props): JSX.Element {
  if (href.startsWith('/ECM/')) {
    return (
      <a href={href} className={className} title={title}>
        {children}
      </a>
    );
  }

  return (
    <RouterLink to={href} className={className} title={title}>
      {children}
    </RouterLink>
  );
}
